import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'
import { Tooltip } from 'react-bootstrap'

import ReaderToolbarSearch from './ReaderToolbarSearch'
import ReaderToolbarButton from './ReaderToolbarButton'
import ReaderToolbarHighlightSwitch from './ReaderToolbarHighlightSwitch'
import ReaderToolbarTools from './ReaderToolbarTools'
import ReaderToolbarLinks from './ReaderToolbarLinks'
import ReaderToolbarNarrateSwitch from './ReaderToolbarNarrateSwitch'

const ReaderToolbar = props => {
  const glossaryTooltip = (
    <Tooltip id="glossary_tooltip">
      {formatMessage('View glossary terms within the course')}
    </Tooltip>
  )

  const flashcardTooltip = (
    <Tooltip id="flashcard_tooltip">
      {formatMessage('View flashcards from this course')}
    </Tooltip>
  )

  const notebookTooltip = (
    <Tooltip id="notebook_tooltip">
      {formatMessage('View the notebook for this course')}
    </Tooltip>
  )

  return (
    <div id="booktools_container_inner" className="h-100">
      <div className="vertical_spacer" />

      <ReaderToolbarSearch coursenum={props.coursenum} />

      <ReaderToolbarButton
        displayButton
        outerDivID="glossary_booktool"
        buttonOverlay={glossaryTooltip}
        buttonStyle="link"
        onClickFunc={props.glossaryModalFunc}
      >
        <div className="fa-fw fal fa-search" />
        &nbsp;{' '}
        <span className="booktools_item_title">
          {formatMessage('Glossary')}
        </span>
      </ReaderToolbarButton>

      <ReaderToolbarButton
        displayButton
        outerDivID="flashcards_booktool"
        buttonOverlay={flashcardTooltip}
        buttonStyle="link"
        buttonHref={'/reader/flashcards/' + props.coursePK + '/'}
      >
        <div className="fa-fw fal fa-clone" />
        &nbsp;{' '}
        <span className="booktools_item_title">
          {formatMessage('Flashcards')}
        </span>
      </ReaderToolbarButton>

      <ReaderToolbarButton
        displayButton={props.allowNotebook}
        outerDivID="notebook_booktool"
        buttonOverlay={notebookTooltip}
        buttonStyle="link"
        buttonHref={'/reader/notebook/' + props.coursePK + '/'}
      >
        <div className="fa-fw fal fa-pen-fancy" />
        &nbsp;{' '}
        <span className="booktools_item_title">
          {formatMessage('Notebook')}
        </span>
      </ReaderToolbarButton>

      <div className="center mt-4 mb-4">
        <div className="separator" />
      </div>

      <ReaderToolbarNarrateSwitch isModal={props.isModal} />

      <ReaderToolbarHighlightSwitch isModal={props.isModal} />

      <ReaderToolbarTools
        allowAuthorTools={props.allowAuthorTools}
        userRole={props.userRole}
        isModal={props.isModal}
      />

      <div className="center mt-4 mb-4">
        <div className="separator" />
      </div>

      <ReaderToolbarLinks
        advancedOptionsModalFunc={props.advancedOptionsModalFunc}
      />
    </div>
  )
}

ReaderToolbar.propTypes = {
  coursePK: PropTypes.string.isRequired,
  coursenum: PropTypes.string.isRequired,
  glossaryModalFunc: PropTypes.func.isRequired,
  allowNotebook: PropTypes.bool.isRequired,
  allowAuthorTools: PropTypes.bool.isRequired,
  userRole: PropTypes.string.isRequired,
  advancedOptionsModalFunc: PropTypes.func.isRequired,
  isModal: PropTypes.bool.isRequired,
}

export default ReaderToolbar
